import { type ReactNode, useEffect } from "react";

import { type MessageFormatElement } from "react-intl";

import { I18nProvider } from "./i18n-provider";
import { setDefaultLocale } from "./model";

type Props<L> = {
  defaultLocale: L;
  messagesGetter: (
    locale: L,
    defaultLocale: L,
  ) => Promise<
    Record<string, MessageFormatElement[]> | Record<string, string> | undefined
  >;
  renderChildren: (locale: L) => ReactNode;
};
export const LocalesProvider = <L extends string>({
  defaultLocale,
  messagesGetter,
  renderChildren,
}: Props<L>) => {
  useEffect(() => {
    setDefaultLocale(defaultLocale);
  });

  return (
    <I18nProvider<L>
      messagesGetter={(locale) => messagesGetter(locale, defaultLocale)}
      renderChildren={renderChildren}
    />
  );
};
